import React from 'react';
import { Content, List, Root as Tabs, Trigger } from '@radix-ui/react-tabs';
import title from 'title';
import type { Maybe } from '@soundxyz/utils';
import { Chip } from '@components/main-components/elements/chips/Chip';
import type { FeedPostModalStep } from '@components/modals/FeedPostModal';
import type { FeedPostResource } from '../types';
import { SelectPlaylist } from './SelectPlaylist';
import { SelectSound } from './SelectSound';

export const PostResource = {
  RELEASE: 'Releases',
  PLAYLIST: 'Playlists',
} as const;

export type PostResource = (typeof PostResource)[keyof typeof PostResource];

export function FeedPostSelectResource({
  selectedResource,
  setSelectedResource,
  selectedTab,
  setTab,
  step,
}: {
  selectedResource: Maybe<FeedPostResource>;
  setSelectedResource: (resource: FeedPostResource | null) => void;
  selectedTab: PostResource;
  setTab: (resource: PostResource) => void;
  step: FeedPostModalStep;
}) {
  return (
    <Tabs value={selectedTab} className="relative flex h-full w-full flex-col">
      <List className="mb-3 flex items-center  gap-2 px-4 lt:px-6">
        <Trigger value={PostResource.RELEASE}>
          <Chip
            text={title(PostResource.RELEASE)}
            isSelected={selectedTab === PostResource.RELEASE}
            onClick={() => {
              setTab(PostResource.RELEASE);
              setSelectedResource(null);
            }}
          />
        </Trigger>
        <Trigger value={PostResource.PLAYLIST}>
          <Chip
            text={title(PostResource.PLAYLIST)}
            isSelected={selectedTab === PostResource.PLAYLIST}
            onClick={() => {
              setTab(PostResource.PLAYLIST);
              setSelectedResource(null);
            }}
          />
        </Trigger>
      </List>

      <Content value={PostResource.RELEASE} className="flex h-full w-full flex-col overflow-auto">
        <SelectSound
          setSelectedResource={setSelectedResource}
          selectedResource={selectedResource}
          step={step}
        />
      </Content>
      <Content value={PostResource.PLAYLIST} className="flex h-full w-full flex-col overflow-auto">
        <SelectPlaylist
          setSelectedResource={setSelectedResource}
          selectedResource={selectedResource}
          step={step}
        />
      </Content>
    </Tabs>
  );
}
